module.exports = __webpack_public_path__ + "img/tw.677448c1.svg";